import { Theme } from "../../data/style/Theme";

export const PlusMinusButton = ({ action, disabled, onClick, alt }) => {
  return (
    <button
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        background: disabled
          ? Theme.palette.dim
          : alt
            ? Theme.palette.surface
            : Theme.palette.card,
        border: `1px solid ${Theme.palette.border}`,
        borderRadius: "6px",
        width: 20,
        height: 20,
        borderColor: Theme.palette.border,
        color: disabled ? Theme.palette.muted : Theme.palette.text,
        fontSize: "0.9rem",
      }}
      disabled={disabled}
      onClick={onClick}
    >
      {action}
    </button>
  );
};
